import { CanDeactivateFn } from '@angular/router';

import type { CMIConfigPage } from './cmi-config';

/** Unsaved branding asks before the route changes; the page owns the confirm. */
export const cmiConfigLeaveGuard: CanDeactivateFn<CMIConfigPage> = (page) => page.confirmLeave();
